// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AOgX","left":"styles_left__rJOm4"};